module.exports = __webpack_public_path__ + "img/circle-notch.e3e30188.svg";